import React from 'react';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { DetailsButton } from 'Components/UI/Accounts/AccountManagement/TableActions';
import {
  setAccountSummaryResource,
  setAchRelationshipResource,
  setInvestigationResource,
} from 'Components/AdvisorApp/Viewport/ApexAdminPortal/ApexAdminPortalActions';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import View from './View';
import { useApexAdminPortalDispatchContext, useApexAdminPortalStateContext } from '../ApexAdminPortalContext';

const AccountsTable = () => {
  const { accountSummaryCollection } = useApexAdminPortalStateContext();
  const apexAdminPortalDispatch = useApexAdminPortalDispatchContext();
  const { rootNodeProps, logEvent } = useEventTrackingLogEvent({ nodeName: 'Accounts Table' });
  return (
    <Box {...rootNodeProps}>
      <View
        collection={accountSummaryCollection}
        onViewMore={{
          columnName: '',
          component: DetailsButton,
          onSubmit: (resource) => {
            setAccountSummaryResource(resource, apexAdminPortalDispatch);
            setAchRelationshipResource(null, apexAdminPortalDispatch);
            setInvestigationResource(null, apexAdminPortalDispatch);
            logEvent('Clicked View More');
          },
        }}
      />
    </Box>
  );
};

export default AccountsTable;
